<template>
  <!-- Footer -->
  <footer class="bg-gray-900 text-white py-12 px-4">
    <div class="max-w-7xl mx-auto">
      <div class="grid md:grid-cols-4 gap-8 mb-8">
        <div>
          <div class="flex items-center space-x-2 mb-4">
            <div class="w-8 h-8 bg-gradient-to-br from-red-500 to-pink-600 rounded-lg"></div>
            <span class="text-xl font-bold">Peachy Pro</span>
          </div>
          <p class="text-gray-400">Professional video editing services for modern creators.</p>
        </div>
        <div>
          <h4 class="font-semibold mb-4">Product</h4>
          <ul class="space-y-2 text-gray-400">
            <li><a href="#features" class="hover:text-white transition-colors">Features</a></li>
            <li><a href="#pricing" class="hover:text-white transition-colors">Pricing</a></li>
            <li><a href="#process" class="hover:text-white transition-colors">How it Works</a></li>
          </ul>
        </div>
        <div>
          <h4 class="font-semibold mb-4">Company</h4>
          <ul class="space-y-2 text-gray-400">
            <li><a href="/about" class="hover:text-white transition-colors">About</a></li>
            <li><a href="/blog" class="hover:text-white transition-colors">Blog</a></li>
            <!-- <li><a href="#" class="hover:text-white transition-colors">Careers</a></li> -->
          </ul>
        </div>
        <div>
          <h4 class="font-semibold mb-4">Legal</h4>
          <ul class="space-y-2 text-gray-400">
            <li>
              <NuxtLink to="/privacy-policy" class="hover:text-white transition-colors">Privacy</NuxtLink>
            </li>
            <li>
              <NuxtLink to="/terms" class="hover:text-white transition-colors">Terms</NuxtLink>
            </li>
          </ul>
        </div>
      </div>
      <div class="border-t border-gray-800 pt-8 text-center text-gray-400">
        <p>&copy; 2025 Peachy Pro Studios. All rights reserved.</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter'
}
</script>

<style scoped>
/* Add any specific styles for the footer here */
</style>